<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 25
  }
})

const height = computed(() => props.height ? props.height : 25)
const width = computed(() => height.value * 26 / 33)

</script>

<template>
  <svg :width=width :height=height viewBox="0 0 33 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"  style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,0,-0.283325)">
        <path d="M5.299,0.283L0.918,0.283C0.411,0.283 0,0.695 0,1.202L0,4.927C0,5.434 0.411,5.846 0.918,5.846L5.299,5.846C5.806,5.846 6.217,5.434 6.217,4.927L6.217,1.202C6.217,0.695 5.806,0.283 5.299,0.283Z" style="fill:rgb(218,0,129);fill-rule:nonzero;"/>
      <path d="M31.988,0.283L28.22,0.283C27.704,0.283 27.301,0.703 27.301,1.202L27.301,16.277C27.301,16.583 26.899,16.696 26.754,16.422L17.992,0.686C17.847,0.428 17.589,0.283 17.283,0.283L11.018,0.283C10.502,0.283 10.1,0.703 10.1,1.202L10.1,25.29C10.1,25.805 10.518,26.209 11.018,26.209L14.787,26.209C15.302,26.209 15.705,25.789 15.705,25.29L15.705,9.763C15.705,9.457 16.107,9.344 16.252,9.618L25.256,25.822C25.401,26.08 25.659,26.225 25.965,26.225L31.956,26.225C32.472,26.225 32.874,25.805 32.874,25.306L32.874,1.202C32.874,0.686 32.456,0.283 31.956,0.283L31.988,0.283Z" style="fill:rgb(32,0,32);fill-rule:nonzero;"/>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
